enum AuthActionType {
    AUTHORIZE_START = 'AUTHORIZE_START',
    AUTHORIZE_CALLBACK_FAILURE = 'AUTHORIZE_CALLBACK_FAILURE',
    AUTHORIZE_CALLBACK_SUCCESS = 'AUTHORIZE_CALLBACK_SUCCESS',
    AUTHORIZE_RESET = 'AUTHORIZE_RESET',
}

export { AuthActionType };
